// A default import, not `{ version }`: webpack 5 refuses named imports from a JSON module
// ("only default export is available soon") and CRA fails to compile.
import pkg from '../../../../package.json';

/**
 * Build identity for the SPA. There is no healthcheck and no server log here, so the only place a
 * deployed bundle can say which build it is, is the browser — hence the one console line at boot
 * and the `window` handle, which lets support ask "what does `__BUILD__` say?" without a rebuild.
 *
 * CRA inlines only `REACT_APP_*`, and `.bitbucket/functions.sh` forwards every such variable as a
 * build arg, so these arrive without a per-variable list anywhere. Unset means a local build.
 */
export interface BuildInfo {
  version: string;
  commit: string;
  builtAt: string;
}

const UNBUILT = 'local';

export const BUILD_INFO: BuildInfo = Object.freeze({
  version: pkg.version,
  commit: process.env.REACT_APP_BUILD_COMMIT || UNBUILT,
  builtAt: process.env.REACT_APP_BUILD_TIME || UNBUILT,
});

export const reportBuildInfo = (): void => {
  (window as unknown as { __BUILD__: BuildInfo }).__BUILD__ = BUILD_INFO;
  // eslint-disable-next-line no-console
  console.info(`build ${BUILD_INFO.version}+${BUILD_INFO.commit} (${BUILD_INFO.builtAt})`);
};
